import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Breadcrumb, BreadcrumbItem, Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { object, func, array } from 'prop-types';
import { startSetSourcesList, startSetOffersSettings } from '../../../../actions/app';
import { startRequestOfferAccess, startRefuseOfferAccess } from '../../../../actions/webmaster';
import { startSetOfferInfo, startSetOfferFiles, resetOffer } from '../../../../actions/offers';
import { startRemoveStream } from '../../../../actions/streams';
import { streams } from '../../../../services/ApiService';
import {
  startSetStreamSettings,
  startSetGlobalPostback,
  startEditGlobalPostback,
} from '../../../../actions/streams';
import { offersConstants } from '../../../../constants/offers';
import Layout from '../../../../components/Layout/Layout';
import Card from '../../../../components/Card/Card';
import OfferCard from '../../components/Offer/OfferCard';
import OfferPixels from '../../../../components/Offer/OfferPixels';
import OfferStats from '../../components/Offer/OfferStats';
import OfferPostClick from '../../../../components/Offer/OfferPostClick';
import OfferNews from '../../../../components/Offer/OfferNews';
import OfferSources from '../../../../components/Offer/OfferSources';
import OfferFiles from '../../../../components/Offer/OfferFiles';
import OfferGeoList from '../../../../components/Offer/OfferGeoList';
import OfferGeoPrices from '../../../../components/Offer/OfferGeoPrices';
import OfferForbiddenGeoList from '../../../../components/Offer/OfferForbiddenGeoList';
import OfferTopLink from '../../../../components/Offer/OfferTopLink';
import OfferTargetAudience from '../../../../components/Offer/OfferTargetAudience';
import LandingRequest from '../../../../components/LandingRequest/LandingRequest';
import DialogModal from '../../../../modals/DialogModal/DialogModal';
import AlertModal from '../../../../modals/AlertModal/AlertModal';
import WithAlert from '../../../../hoc/WithAlert';
import OfferHasFlowsModal from '../../../../components/Offer/OfferHasFlowsModal';
import OfferCardItem from '../../../../components/Offer/OfferCardItem';
import OffersListTable from '../../components/Offers/OffersListTable';
import OfferLandings from '../../components/Offer/OfferLandings';
import OfferCardControls from '../../../../components/Offer/OfferCardControls';
import GlobalPostbackForm from '../../../..//components/Postback/GlobalPostbackForm.js';
import OfferFlows from '../../components/Offer/OfferFlows';
import OfferSupportHours from '../../../../components/Offer/OfferSupportHours';

class OfferPage extends Component {
  static propTypes = {
    offer: object.isRequired,
    countries: array.isRequired,
    currencies: array.isRequired,
    sources: array.isRequired,
    startSetOfferInfo: func.isRequired,
    startSetSourcesList: func.isRequired,
    startSetOffersSettings: func.isRequired,
    startSetOfferFiles: func.isRequired,
    startRequestOfferAccess: func.isRequired,
    startRefuseOfferAccess: func.isRequired,
    showAlert: func.isRequired,
  };

  static defaultProps = {
    offer: {},
    countries: [],
    currencies: [],
    sources: [],
  };

  constructor(props) {
    super(props);

    const { offer } = props;

    this.state = {
      loading: false,
      loadingPostbackForm: false,
      offerId: offer && offer.id ? offer.id : 0,
      confirmModal: false,
      errorModal: false,
      postbackModal: false,
      offerHasFlowsModalOpen: false,
      error: {},
      postbackResponse: null,
      flowId: null,
      modalIsOpen: false,
    };
  }

  componentDidMount() {
    const { match } = this.props.data;
    const id = parseInt(match.params.id, 10);

    this.setState(() => ({ loadingPostbackForm: true }));

    this.props
      .startSetStreamSettings()
      .then(() => this.props.startSetGlobalPostback())
      .then(() => this.setState(() => ({ loadingPostbackForm: false })))
      .catch(({ response = {} }) => this.handlePostbackError(response));

    this.props.startSetOffersSettings().then(() => this.getOffer(id));
  }

  componentWillUnmount() {
    this.props.resetOffer();
  }

  getOffer = (id) =>
    this.props
      .startSetOfferInfo(id)
      .then((response) => response.type)
      .then((type) => {
        if (type === offersConstants.SET_OFFER_FAILURE) {
          this.props.history.replace('/404');
        } else {
          this.setState(() => ({ offerId: id }));

          if (this.props.sources.length === 0) {
            this.props.startSetSourcesList();
          }

          this.props.startSetOfferFiles(id);
        }
      });

  handleRequestOfferAccess = (offerId) => {
    const { intl } = this.props;
    if (this.state.loading) {
      return;
    }

    this.setState(() => ({ loading: true }));

    this.props
      .startRequestOfferAccess(offerId)
      .then(() => this.getOffer(offerId))
      .then(() => this.setState(() => ({ loading: false })))
      .then(() => {
        this.props.showAlert({
          alertType: 'success',
          dismissable: false,
          closeInSeconds: 3,
          message: intl.formatMessage(
            {
              id: 'offer.allowed-access.message',
              defaultMessage: `Access to «{offer}» is provided`,
            },
            { offer: this.props.offer.title },
          ),
        });
      })
      .catch(({ response }) => {
        if (response && response.data) {
          const { message: error } = response.data.error;

          if (error.type && error.type === 'api.account.offer_request_ticket') {
            this.props.data.history.push(`/tickets/create?offer=${offerId}&theme=offerRequest`);
          } else {
            this.setState(() => ({
              errorModal: true,
              loading: false,
              offerId,
              error,
            }));
          }
        }
      });
  };

  handleRefuseOfferAccess = (offerId) => {
    this.setState(
      () => ({ offerId }),
      () => {
        this.toggleModal();
      },
    );
  };

  handleError = () => {
    this.setState(
      () => ({ errorModal: false }),
      () => {
        const { error, offerId } = this.state;
        const { history } = this.props;

        if (history) {
          switch (error.type) {
            case 'api.purses.empty':
              history.push('/profile/payment-data');
              break;
            case 'api.profile.phone.empty':
            case 'api.profile.phone.not_approved':
              history.push('/profile/edit');
              break;
            case 'api.account.offer_request_ticket':
              history.push(`/tickets/create?offer=${offerId}&theme=offerRequest`);
              break;
            default:
              return false;
          }
        }
      },
    );
  };

  checkPostback = (postback) => {
    this.setState(() => ({ loadingPostbackForm: true }));

    streams
      .checkPostback(postback)
      .then(({ items }) => {
        const data = items[0];

        this.setState(() => ({
          loadingPostbackForm: false,
          postbackResponse: data.response,
        }));

        this.togglePostbackModal();
      })
      .catch(({ response = {} }) => this.handlePostbackError(response));
  };

  handleModal = () => {
    const { offerId: id } = this.state;
    this.toggleModal();
    this.props.startRefuseOfferAccess(id).then(() => this.getOffer(id));
  };

  toggleModal = () => {
    this.setState((prevState) => ({ confirmModal: !prevState.confirmModal }));
  };

  togglePostbackModal = () => {
    this.setState((prevState) => ({ postbackModal: !prevState.postbackModal }));
  };

  getBaseCurrency = () => {
    const { offer } = this.props;
    if (offer.currencies) {
      return offer.currencies[0];
    }
    return null;
  };
  handlePostbackError = (response) => {
    this.setState(() => ({ loadingPostbackForm: false }));

    if (response.data && response.data.error) {
      const { message: error } = response.data.error;

      this.props.showAlert({
        alertType: 'danger',
        message: error.message,
        dismissable: false,
        closeInSeconds: 3,
      });
    }
  };

  handlePostbackSubmit = (data) => {
    const { intl } = this.props;
    this.setState(() => ({ loadingPostbackForm: true }));
    this.props
      .startEditGlobalPostback(data)
      .then(() => {
        this.setState(() => ({ loadingPostbackForm: false }));

        this.props.showAlert({
          alertType: 'success',
          message: iFMessage({ intl, id: 'postback.global.saved' }),
          dismissable: false,
          closeInSeconds: 3,
        });
      })
      .catch(({ response = {} }) => this.handlePostbackError(response));
  };

  handleFlowCreate = (offerId) => {
    const {
      data: { history },
    } = this.props;
    history.push(`/tools/flows/create?offer=${offerId}`);
  };

  offerHasFlowsModalToggle = () => {
    this.setState((prevState) => ({
      offerHasFlowsModalOpen: !prevState.offerHasFlowsModalOpen,
    }));
  };

  offerHasFlowsModalOpen = () => {
    this.setState(() => ({
      offerHasFlowsModalOpen: true,
    }));
  };

  removeFlow = () => {
    const { flowId: id } = this.state;
    const { startRemoveStream } = this.props;
    const offerId = this.props.offer.id;
    startRemoveStream(id)
      .then(() => this.props.startSetOffersSettings())
      .then(() => this.getOffer(offerId))
      .then(() => this.toggleRemoveFlowModal());
  };

  toggleRemoveFlowModal = () => {
    this.setState(({ modalIsOpen }) => ({ modalIsOpen: !modalIsOpen }));
  };

  handleRemoveFlow = (flowId) => {
    this.setState(
      () => ({ flowId }),
      () => {
        this.toggleRemoveFlowModal();
      },
    );
  };
  render() {
    const { offer, sources, offerSettings, countries, site_key, profile, settings } = this.props;
    const {
      loading,
      error,
      errorModal,
      offerHasFlowsModalOpen,
      loadingPostbackForm,
      postbackModal,
      postbackResponse,
      modalIsOpen,
    } = this.state;
    const baseCurrency = this.getBaseCurrency();
    const controls = [
      <Link
        to={`/tickets/create?theme=pixelRequest&offer=${offer.id}`}
        className="btn btn-primary btn-sm"
      >
        <FormattedMessage
          id="offer.buttons.pixels-request"
          defaultMessage="Did you find a higher payout?"
        />
      </Link>,
      <Link
        to={`/tickets/create?theme=geoRequest&offer=${offer.id}`}
        className="btn btn-primary btn-sm"
      >
        <FormattedMessage id="offer.buttons.geo-request" defaultMessage="Not enough wide GEO?" />
      </Link>,
    ];

    return (
      <Layout title={offer.title} className="offer-page">
        <Layout.LeftCol md="12" className="left-col">
          {offer.title && <h3 className="offer-title page-title">{offer.title}</h3>}
          <Card className="card-loading-silent" loading={loading}>
            <Card.Header>
              <Breadcrumb>
                <BreadcrumbItem>
                  <Link to="/offers/all">
                    <FormattedMessage id="offers.breadcrumb" defaultMessage="All offers" />
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>{offer.title}</BreadcrumbItem>
              </Breadcrumb>
            </Card.Header>

            {offer.id && (
              <OfferCard
                offerSettings={offerSettings}
                onRequestOfferAccess={this.handleRequestOfferAccess}
                onRefuseOfferAccess={this.handleRefuseOfferAccess}
                onFlowCreate={this.handleFlowCreate}
                offer={offer}
              />
            )}
          </Card>

          {offer.id && (
            <Card.WithControls
              title="offers.table.withholdings"
              defaultMessage="Withholdings"
              controls={offer.modifies.g ? [] : controls}
              collapsing={true}
            >
              <Card.Body>
                <OffersListTable
                  prices={offer.offer_geo.prices}
                  pixels={offer.pixels}
                  id={offer.id}
                  coins={offer.modifies.coins}
                  countries={countries}
                />
              </Card.Body>
            </Card.WithControls>
          )}

          {baseCurrency && offer.landings && offer.landings.length > 0 && (
            <OfferLandings
              landings={offer.landings}
              currency={baseCurrency}
              offer={offer}
              transits={offer.transits}
              site_key={site_key}
              profile={profile}
              connectOffer={this.handleRequestOfferAccess}
            />
          )}

          {offer.id && offer.modifies.is_cdn && <LandingRequest offerId={offer.id} />}

          <GlobalPostbackForm
            loading={loadingPostbackForm}
            postback={settings.globalPostback}
            statuses={settings.postBackStatuses}
            onCheckPostback={this.checkPostback}
            onSubmit={this.handlePostbackSubmit}
          />

          {offer.flows && offer.flows.length > 0 && (
            <OfferFlows
              removeFlow={this.removeFlow}
              handleRemoveFlow={this.handleRemoveFlow}
              toggleModal={this.toggleRemoveFlowModal}
              flows={offer.flows}
            />
          )}

          {/* !offer.modifies.g - стата не должна показыватсья на офферах гемблинга */}
          {baseCurrency && offer.stats && !offer.modifies.g && (
            <OfferStats collapsing={true} statistics={offer.stats} currency={baseCurrency} />
          )}

          {offer.id && <OfferNews offerId={offer.id} />}
        </Layout.LeftCol>

        <Layout.RightCol md="12" className="right-col offer-additional-info">
          <div className="offer-additional-info-inner">
            {offer.rules && (
              <Card className="offer-rules-card">
                <Card.Body>
                  <h6>
                    <FormattedMessage defaultMessage="Offer's Rules" id="offer.rules" />
                  </h6>
                  <OfferCardItem
                    id="offer.rules"
                    className="offer-rules"
                    defaultMessage="Offer's Rules"
                    html={offer.rules}
                  />
                </Card.Body>
              </Card>
            )}

            {offer.id && (
              <OfferCardControls
                offerId={offer.id}
                isMy={offer.modifies.is_my}
                hasAccess={offer.admit.has_access}
                hasPromo={offer.hasPromo}
                onRequestOfferAccess={this.handleRequestOfferAccess}
                onRefuseOfferAccess={this.handleRefuseOfferAccess}
                onFlowCreate={this.handleFlowCreate}
              />
            )}

            {offer.id && <OfferSupportHours offerId={offer.id} />}

            {offer.countriesList && offer.countriesList.length > 0 && !offer.modifies.is_cdn && (
              <OfferGeoList isGambling={offer.modifies.g} countries={offer.countriesList} />
            )}

            {offer.forbiddenGeo && offer.forbiddenGeo.length > 0 && !offer.modifies.is_cdn && (
              <OfferForbiddenGeoList countries={offer.forbiddenGeo} />
            )}

            {offer.files && offer.files.length > 0 && <OfferFiles files={offer.files} />}

            {offer.sources && offer.sources.length > 0 && (
              <OfferSources
                sources={sources}
                selected={offer.sources}
                invert={offer.sources_inversion}
              />
            )}
            {offer.expire !== undefined && <OfferPostClick hold={offer.expire} />}
          </div>
        </Layout.RightCol>

        <DialogModal
          open={this.state.confirmModal}
          onConfirm={this.handleModal}
          onCancel={this.toggleModal}
          message={<FormattedMessage id="offer.modal.remove" defaultMessage="Remove offer" />}
        />

        {error.message && (
          <AlertModal open={errorModal} message={error.message} onClose={this.handleError} />
        )}

        <OfferHasFlowsModal
          toggle={this.offerHasFlowsModalToggle}
          open={offerHasFlowsModalOpen}
          flows={offer.flows}
          offerId={offer.id}
        />

        <FormattedMessage
          id="flows.modal.message"
          defaultMessage="Would you like to remove this flow?"
        >
          {(message) => (
            <DialogModal
              open={modalIsOpen}
              message={message}
              onConfirm={this.removeFlow}
              onCancel={this.toggleRemoveFlowModal}
            />
          )}
        </FormattedMessage>

        {/* postback modal  */}
        <Modal size="lg" isOpen={postbackModal} toggle={this.togglePostbackModal}>
          <ModalHeader toggle={this.togglePostbackModal}>
            <FormattedMessage id="flow.modal.postback-response" defaultMessage="Postback reponse" />
          </ModalHeader>
          <ModalBody>
            <pre>{postbackResponse}</pre>
          </ModalBody>
        </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  const { countries, sources, currencies } = state.app.globalSettings;
  const { profile } = state.webmaster;
  const settings = state.streams.settings;

  return {
    profile,
    countries,
    sources,
    settings,
    currencies,
    offer: state.offers.selected,
    offerSettings: state.app.settings.offer,
    site_key: state.webmaster.profile.site_key,
  };
};

const mapDispatchToProps = (dispatch) => ({
  startSetOffersSettings: () => dispatch(startSetOffersSettings()),
  startSetSourcesList: () => dispatch(startSetSourcesList()),
  startSetOfferInfo: (offerId) => dispatch(startSetOfferInfo(offerId)),
  startSetOfferFiles: (offerId) => dispatch(startSetOfferFiles(offerId)),
  startRequestOfferAccess: (offerId) => dispatch(startRequestOfferAccess(offerId)),
  startRefuseOfferAccess: (offerId) => dispatch(startRefuseOfferAccess(offerId)),
  resetOffer: () => dispatch(resetOffer()),
  startSetStreamSettings: () => dispatch(startSetStreamSettings()),
  startSetGlobalPostback: () => dispatch(startSetGlobalPostback()),
  startEditGlobalPostback: (data) => dispatch(startEditGlobalPostback(data)),
  startRemoveStream: (streamId) => dispatch(startRemoveStream(streamId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithAlert(injectIntl(OfferPage)));
